export const setPageTitle = (title: string) => {
  document.title = `${title} | JLS Apps`;
};
